var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitemapSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3255_11501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 8.78125C22.1667 6.03809 24.4062 3.8125 27.1667 3.8125H33.8333C36.5938 3.8125 38.8333 6.03809 38.8333 8.78125V15.4062C38.8333 18.1494 36.5938 20.375 33.8333 20.375H33V24.5156H48.8333C52.0521 24.5156 54.6667 27.1139 54.6667 30.3125V33.625H55.5C58.2604 33.625 60.5 35.8506 60.5 38.5938V45.2188C60.5 47.9619 58.2604 50.1875 55.5 50.1875H48.8333C46.0729 50.1875 43.8333 47.9619 43.8333 45.2188V38.5938C43.8333 35.8506 46.0729 33.625 48.8333 33.625H49.6667V30.3125C49.6667 29.857 49.2917 29.4844 48.8333 29.4844H33V33.625H33.8333C36.5938 33.625 38.8333 35.8506 38.8333 38.5938V45.2188C38.8333 47.9619 36.5938 50.1875 33.8333 50.1875H27.1667C24.4062 50.1875 22.1667 47.9619 22.1667 45.2188V38.5938C22.1667 35.8506 24.4062 33.625 27.1667 33.625H28V29.4844H12.1667C11.7083 29.4844 11.3333 29.857 11.3333 30.3125V33.625H12.1667C14.9271 33.625 17.1667 35.8506 17.1667 38.5938V45.2188C17.1667 47.9619 14.9271 50.1875 12.1667 50.1875H5.5C2.73958 50.1875 0.5 47.9619 0.5 45.2188V38.5938C0.5 35.8506 2.73958 33.625 5.5 33.625H6.33333V30.3125C6.33333 27.1139 8.94792 24.5156 12.1667 24.5156H28V20.375H27.1667C24.4062 20.375 22.1667 18.1494 22.1667 15.4062V8.78125Z",
    fill: "#8DAF61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3255_11501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 53,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemapSolid1);
export default __webpack_public_path__ + "static/media/sitemap-solid 1.86976c1df8debe39231635344a6ab059.svg";
export { ForwardRef as ReactComponent };